import { defineMessage } from '@lingui/macro';

export const ADMIN = 1;
export const VENDOR_MANAGER = 5;
export const STORE_MANAGER = 10;
export const STORE_PERSON = 11;

export const ADMIN_WHITELIST = [ADMIN, VENDOR_MANAGER, STORE_MANAGER];
export const ALL_ROLES = [ADMIN, VENDOR_MANAGER, STORE_MANAGER, STORE_PERSON];

export const adminRolesList = {
  [VENDOR_MANAGER]: defineMessage({
    id: 'role.vendor.manager',
    message: 'Vendor Manager',
  }),
  [STORE_MANAGER]: defineMessage({
    id: 'role.store.manager',
    message: 'Store Manager',
  }),
  [STORE_PERSON]: defineMessage({
    id: 'role.store.person',
    message: 'Store Person',
  }),
};
